import KosRouterComponent from './routes/KosRouterComponent';

function App() {
    return (
        <div className='App'>
            <KosRouterComponent />
        </div>
    );
}

export default App;
